import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { client as queryClient } from '../../../components/rest/react-query';
import { Checkout } from '../../../pages/checkout/CheckoutPage';
import { renderApp } from './utils/utils';

renderApp(
  <QueryClientProvider client={queryClient}>
    <Router>
      <Checkout testid="checkout" />
    </Router>
  </QueryClientProvider>,
  'checkout-app'
);
